// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"Pagination_paginationContainer__21neO","pagination":"Pagination_pagination__13Dwm","number":"Pagination_number__3NYav"};